var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useRef, useState } from 'react';
function useLazyFetch(promiseFunction, lazy) {
    if (lazy === void 0) { lazy = true; }
    var cancelRequest = useRef(false);
    var _a = __read(useState(), 2), error = _a[0], setError = _a[1];
    var _b = __read(useState(false), 2), loading = _b[0], setIsLoading = _b[1];
    var _c = __read(useState(null), 2), data = _c[0], setData = _c[1];
    var fetch = useCallback(function () {
        if (!promiseFunction)
            return;
        cancelRequest.current = false;
        setIsLoading(true);
        var promiseOrFunction;
        if (promiseFunction instanceof Promise) {
            promiseOrFunction = promiseFunction;
        }
        else {
            promiseOrFunction = promiseFunction();
        }
        promiseOrFunction.then(function (res) {
            setIsLoading(false);
            setData(res);
            return res;
        }).catch(function (error) {
            setIsLoading(false);
            setError(error);
            // return error.response ?? error.response.data ?? error;
            return error;
        });
        if (cancelRequest.current)
            return;
    }, [promiseFunction]);
    useEffect(function () {
        if (!lazy && data === null) {
            fetch();
        }
        return function () {
            cancelRequest.current = true;
        };
    }, []);
    if (lazy) {
        return { data: data, loading: loading, error: error, fetch: fetch };
    }
    return { data: data, loading: loading, error: error };
}
export default useLazyFetch;
